import { Directive, HostBinding, Input } from '@angular/core';
import { ExplorerHash, ExplorerPaths } from '@app/core/models/main-menu.model';
import { generateExplorerHref } from '@app/core/utilities/url.utilities';

@Directive({
  selector: '[adsptExplorerHref]',
  standalone: true,
})
export class ExplorerHrefDirective {
  @Input('adsptExplorerHref')
  path?: ExplorerPaths;

  @Input()
  filters?: ExplorerHash;

  @HostBinding('target')
  readonly target = '_blank';

  @HostBinding('href')
  get href(): string | null {
    return generateExplorerHref(this.path, this.filters);
  }
}
